var _path, _path2, _path3, _g, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkilledBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 52,
    viewBox: "0 0 47 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0621 47.4552C31.9416 47.8244 31.8118 44.5589 40.1467 39.6534C42.1107 33.2857 44.6032 17.6792 45.0007 7.043C39.0973 3.91757 31.6723 2.08243 23.7687 1.78708C16.0333 1.49801 8.6197 2.73654 2.54473 5.33015C2.28708 12.2247 2.15122 18.1135 2.46718 23.1772C4.33002 38.315 16.0083 47.229 22.0621 47.4552Z",
    fill: "url(#paint0_linear_180_250)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5418 49.3128C42.9752 44.3931 44.3914 32.4057 45.3714 7.30924C39.468 4.1838 32.043 2.34867 24.1394 2.05332C16.404 1.76425 8.99043 3.00277 2.91546 5.59638C2.01645 30.7801 2.48888 42.9222 22.5418 49.3128ZM24.0687 3.94513C31.2156 4.2122 37.8513 5.76524 43.392 8.45613C42.4297 31.9535 40.9329 42.717 22.6172 47.2949C4.65217 41.3612 3.96602 30.4319 4.80532 6.84578C10.4426 4.6989 17.0901 3.68434 24.0687 3.94513Z",
    fill: "url(#paint1_linear_180_250)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4915 50.6582L22.1583 50.5615C12.0914 47.3226 6.41906 42.5219 3.67023 34.9676C1.077 27.756 1.17981 18.2455 1.65269 5.59135L1.68254 4.79259L2.45183 4.48455C8.78219 1.81628 16.2814 0.538861 24.227 0.835784C32.2988 1.13742 39.8484 3.0193 46.0008 6.23824L46.7029 6.60127L46.6731 7.40004C46.1613 19.9685 45.5961 29.4617 42.4298 36.4581C39.1248 43.7862 33.11 48.1502 22.873 50.5882L22.4915 50.6582ZM4.14682 6.44234C3.28081 30.7432 3.91707 41.8811 22.55 47.966C41.6287 43.2482 43.0509 32.2294 43.9963 8.05779C38.3342 5.23606 31.4494 3.58951 24.0503 3.31301C16.8614 3.04437 10.0006 4.13516 4.14682 6.44234Z",
    fill: "url(#paint2_linear_180_250)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_180_250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5494 36L22.4274 31.3965L13.4816 31.3965C12.6603 31.3965 12 30.9061 12 30.2962L12 15.1004C12 14.4904 12.6603 14 13.4816 14L36.5184 14C37.3397 14 38 14.4904 38 15.1004L38 30.2961C38 30.9061 37.3397 31.3965 36.5184 31.3965L29.1106 31.3965L16.5494 36Z",
    fill: "url(#paint3_linear_180_250)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3744 36L22.0263 30.6402L13.4246 30.6402C12.6349 30.6402 12 30.1711 12 29.5876L12 15.0525C12 14.4691 12.6349 14 13.4246 14L35.5754 14C36.3651 14 37 14.4691 37 15.0525L37 29.5876C37 30.1711 36.3651 30.6402 35.5754 30.6402L28.4525 30.6402L16.3744 36Z",
    fill: "url(#paint4_linear_180_250)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_180_250",
    x: 12,
    y: 14,
    width: 37,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 11,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_180_250"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_180_250",
    x1: 31.9999,
    y1: 48,
    x2: 6.99994,
    y2: 3.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C61F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEAB02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_180_250",
    x1: 5.99996,
    y1: 24.8929,
    x2: 46,
    y2: 24.8929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.163159,
    stopColor: "#FFEA8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267469,
    stopColor: "#E3AB29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6592,
    stopColor: "#FFEA8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3A922"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_180_250",
    x1: 10.5,
    y1: 4,
    x2: 13.5,
    y2: 20.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3073,
    stopColor: "#E3AB29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6592,
    stopColor: "#FFEA8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3A922"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_180_250",
    x1: 21.6087,
    y1: 12.7308,
    x2: 24.8742,
    y2: 31.0416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FDE587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0002,
    stopColor: "#FFEA8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#FFEA8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#E3A922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489483,
    stopColor: "#E3A923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#E3A922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.760417,
    stopColor: "#E3AB29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#E3A922"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_180_250",
    x1: 25,
    y1: 29.5,
    x2: 10.9772,
    y2: 17.5459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3AB29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.602928,
    stopColor: "#FFEA8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771173,
    stopColor: "#FFCF25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEA8F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkilledBadge);
export default __webpack_public_path__ + "static/media/skilled-badge.4b95cd17f27f27d4ac2661a56c2b71dd.svg";
export { ForwardRef as ReactComponent };